import React, { useContext, useState } from 'react';
import { AppBar, Toolbar, IconButton, Typography, Box, Avatar, Badge, Menu, MenuItem } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../Contexts/AuthContext';
import authAPI from '../../Services/authAPI';

const Header = () => {
  const { firstname = "Utilisateur", lastname = "", setIsAuthenticated } = useContext(AuthContext); // Valeurs par défaut
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleAvatarClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    authAPI.logout();
    setIsAuthenticated(false);
    handleClose();
    navigate("/"); // Rediriger vers la page de connexion
  };

  const initials = `${firstname[0].toUpperCase()}${lastname ? lastname[0].toUpperCase() : ''}`;

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, backgroundColor: '#ffffff', color: '#333' }}>
      <Toolbar>
        <Box sx={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <Typography variant="h6" noWrap component="div">
            Medclick admin
          </Typography>
          <IconButton color="inherit" aria-label="search" sx={{ ml: 2 }}>
            <SearchIcon />
          </IconButton>
        </Box>
        <IconButton color="inherit">
          <Badge badgeContent={5} color="error">
            <NotificationsIcon />
          </Badge>
        </IconButton>
        <IconButton color="inherit">
          <SettingsIcon />
        </IconButton>
        <Avatar 
          sx={{ ml: 2, bgcolor: 'primary.main', cursor: 'pointer' }}
          onClick={handleAvatarClick}
        >
          {initials}
        </Avatar>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          <MenuItem onClick={handleLogout}>Déconnexion</MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
